export default {
  getMonthEfficiency: state => term => {
    if (!state.efficiency) return null

    return state.efficiency[term]
  },
  portfolios: state => state.portfolios,
}
